export default {
  title: 'Keep in Touch',
  form: {
    name: 'Full name',
    phone: 'Phone',
    email: 'Email',
    help: 'How can we help?',
    agree: 'I agree to have my details added to the mailing list to receive information and updates.',
    send: 'Send',
    success: 'Your message was sent successfully!',
    error: 'Your message was not sent, please try again.',
  },
  details: {
    address: '3 Shenkar St., Herzliya Pituach',
    phone: 'Phone: 050-7683557',
    email: 'service@polaris-fin.co.il',
  },
};
